<template>
    <div class="customize page-cont">
        <h1 class="tit">{{infoTit}}</h1>
        <div class="customize-info">
            <div class="info" v-if='infoData.abstract'>
                <h3>{{infoData.abstract.tit}}</h3>
                <div class="info-txt abstrac-tit">
                    <p v-for="(item,index) in infoData.abstract.list" :key="index">{{item}}</p>
                </div>
                <div class="" v-if="infoData.abstract.imgList">
                    <div class="info-img" v-for="(img,num) in infoData.abstract.imgList" :key="num">
                        <img :src="img.pic" :width="img.width">
                    </div>
                </div>
            </div>
            <!-- 样例报告 -->
            <div class="info" v-if='infoData.example'>
                <h3>{{infoData.example.tit}}</h3>
                <div class="info-txt">
                    <p class="txt" v-for="(item,index) in infoData.example.list" :key="index"> 
                        <a :href="item.href" target="_blank" v-html="item.pdfTit"></a>
                        <!-- <a :href="item.href" @click.prevent="toPdf(item)" target="_blank" v-html="item.pdfTit"></a> -->
                    </p>
                </div>
            </div>
            <!-- 课题组成果 -->
            <div class="info" v-if='infoData.achievement'>
                <h3>{{infoData.achievement.tit}}</h3>
                <div class="info-txt">
                    <div  v-for="(item,index) in infoData.achievement.list" :key="index">
                        <p class="txt">
                            <a :href="item.href" target="_blank" v-html="item.pdfTit"></a>
                        </p>
                        <p class="txt pad20">{{item.txt}}</p>
                    </div>
                    
                </div>
            </div>

            <!-- 平台链接 -->
            <div class="info" v-if='infoData.platform'>
                <h3>{{infoData.platform.tit}}</h3>
                <div class="info-txt">
                    <p class="txt" v-if='infoData.platform.href' >
                        <a :href="infoData.platform.href" v-html="infoData.platform.href"></a>
                    </p>
                    <p v-else>暂不对外开放。</p>
                </div>
            </div>
            <div class="info">
                <h3>联系我们</h3>
                <div class="info-txt">
                    <p class="txt">如您有相似平台构建需求，欢迎与我们取得联系：</p>
                    <p class="txt">中国中医科学院中医药信息研究所 中医药大健康智能研发中心</p>
                    <p class="txt">联系电话: 010-64089619; 13522583261</p>
                    <p class="txt">客服QQ: 2778196938</p> 
                    <p class="txt">客服微信：</p>
                    <div class="code">
                        <img width="100%" src="../../assets/images/code.png" alt="">
                    </div> 
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf' 
import customizeData from './customizeData.js'
export default {
    components: {pdf},
    data() {
        return {
            infoData:{},
            infoTit:'',  
            sequence:this.$route.query.sequence||'1',
        }
    },
    watch: {},
    mounted() {
        this.infoData=customizeData.customize[this.sequence-1].info;
        this.infoTit=customizeData.customize[this.sequence-1].tit;
        document.title =  this.infoTit;
        // console.log(this.infoData)
    },
    methods: { 
    }
}
</script>
<style lang='less' scoped>
.customize{
    // box-shadow:0px 3px 12px 0px #c4bfbc;
    // padding: 30px 50px 120px;
    ::v-deep .el-drawer__header{
        margin-bottom: 14px;
        padding-top:14px;
        font-weight: bold;
        font-size: 16px;
        color: #000;
    }
    ::v-deep .el-drawer__container{
        min-width:1000px;
    }
    h1{
        text-align: center;
        margin-bottom: 30px;
        font-size: 34px;
    }
    h3{ 
        padding-left: 20px;
        color: #32446D;
        font-size: 26px;
        height: 26px;
        line-height: 26px;
        border-left: 4px solid #32446D;
        margin-bottom: 20px;
        text-align: left;
    }
    .info{
        margin-bottom: 30px;
        .code{
            width: 300px;
            padding-left: 100px;
        }
    }
    p{
        padding:6px 0 20px 40px;
    }
    .info-txt{
        font-size: 16px;
        &.abstrac-tit{
            text-indent: 2em;
        }
        .txt{
            padding:6px 0 0 40px;
            a{
                display: inline;
                // font-weight: bold;
                color: #396de7;
                &:hover{
                    color: #333;
                }
            }
        }
        .pad20{
            padding:20px 0 20px 40px;
        }
    } 
    .info-img{
        text-align: center;
    }
    
}
</style>